import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/component/Home';
import Contacts from './pages/Contacts';
 import AdminLogin from "./pages/AdminLogin";
import AdminPanel from "./pages/AdminPanel";
import ApplicationForm from "./pages/ApplicationForm";
import Applications from "./pages/Applications";
 import RegistrationPage from "./pages/RegistrationPage";
import ApplicationForm2 from "./pages/ApplicationForm2";
import UserManagementPage from "./pages/UserManagementPage";
import ClientCardManagementPage from "./pages/ClientCardManagementPage";
import ServiceManagementPage from "./pages/ServiceManagementPage";
import PhoneNumberModal from './pages/PhoneNumberModal';
import RenderProfilePage from "./pages/RenderProfilePage";
import CarsInfoPage from "./pages/component/CarsInfoPage";
import CarsInfoPageBlock from "./pages/component/CarsInfoPageBlock";
import CarTemplatesManagementPage from "./pages/CarTemplatesManagementPage";
import CompaniesManagementPage from "./pages/CompaniesManagementPage";
import UserMngById from "./pages/UserMngById";
import CarSelectorPageModal from "./pages/CarSelectorPageModal";
 import Home2 from "./pages/Home2";
import config from './pages/config/config';
import NewsPageAdmin from "./pages/newsadmin/NewsPageAdmin";
import EditServicePage from "./pages/EditServicePage";
import OrdersAdminPage2 from "./pages/OrdersAdminPage2";


const { apiUrl1, apiUrl2, port1, port2 } = config;


// Защищённый маршрут
function ProtectedRoute({ children }) {
    const isAdminAuthenticated = localStorage.getItem('adminAuth') === 'true';
    return isAdminAuthenticated ? children : <Navigate to="/panel/admin-login" />;
}

function App() {
    const [isCodeVerified, setIsCodeVerified] = useState(null); // null – загрузка, true/false – результат

    useEffect(() => {
        document.title = "ROAD-ASSIST";
    }, []);


    useEffect(() => {
        const verifyCode = async () => {
            const code = localStorage.getItem('verificationCode');
            const phone = localStorage.getItem('phoneNumber');
            console.info(code + "  " + phone);
            if (!code || !phone) {
                setIsCodeVerified(false);
                return;
            }

            try {
                const response = await fetch(
                    `${apiUrl1}/api/verification-codes/verify-code`,
                    {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({ phone, verifyCode: Number(code) }),
                    }
                );

                const result = await response.json();
                setIsCodeVerified(result === true);
            } catch (error) {
                setIsCodeVerified(false);
            }
        };

        verifyCode();
    }, []);

    if (isCodeVerified === null) {
        return <div>Загрузка...</div>; // Показываем загрузку
    }




    return (
        <Router>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/panel/user-management" element={<UserManagementPage />} />
                <Route path="/panel/user-mng-by-id" element={<UserMngById />} />
                <Route path="/panel/disc-card" element={<ClientCardManagementPage />} />
                <Route path="/panel/news-admin" element={<NewsPageAdmin />} />
                <Route path="/panel/companies-mng-panel" element={<CompaniesManagementPage />} />
                <Route path="/panel/cars-templates-panel" element={<CarTemplatesManagementPage />} />
                <Route path="/panel/orders-panel" element={<OrdersAdminPage2 />} />
                <Route path="/panel/service-mng-panel" element={<ServiceManagementPage />} />
                 <Route path="/registration-page" element={<RegistrationPage />} />
                <Route path="/phone-number-modal" element={<PhoneNumberModal />} />
                <Route path="/application-form" element={<ApplicationForm />} />
                <Route path="/application-form2" element={<ApplicationForm2 />} />
                <Route path="/applications" element={<Applications />} />
                <Route path="/contacts" element={<Contacts />} />
                 <Route path="/panel/admin-login" element={<AdminLogin />} />
                <Route path="/panel/edit-profile_auto/:id" element={<EditServicePage />} />
                <Route
                    path="/panel/admin-panel"
                    element={
                        <ProtectedRoute>
                            <AdminPanel />
                        </ProtectedRoute>
                    }
                />
                {/* ✅ Правильная защита маршрута profile-page */}
                <Route path="/profile-page" element={<RenderProfilePage />} />
                <Route path="/carsinfopage" element={<CarsInfoPage />} />
                <Route path="/cars-info-block" element={<CarsInfoPageBlock />} />
                <Route path="/car-selector-modal" element={<CarSelectorPageModal />} />
                <Route path="/home2" element={<Home2 />} />
            </Routes>
        </Router>
    );
}

export default App;
